<template>
  <div
    ref="dropdown"
    :class="[
      'dropdown',
      'd-flex',
      'align-center',
      'justify-center',
      { 'dropdown-open': open },
      { round },
    ]"
    v-bind="$attrs"
    @mouseenter="mouseenter($event); onMouseenter($event)"
    @mouseleave="mouseleave($event); onMouseleave($event)"
    @click="onClick($event)"
    v-on="inputListeners"
  >
    <slot />
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'SubmenuDropdown',
  provide() {
    return {
      dropdownData: computed(() => ({
        activeElement: this.activeElement,
        listWidth: this.listWidth,
        minWidth: this.minWidth,
        outsideRoot: this.outsideRoot,
        handleActiveElementChange: this.handleActiveElementChange,
        closeOnClick: this.closeOnClick,
        right: this.right,
        onClick: this.onClick,
        onMouseenter: this.onMouseenter,
        onMouseleave: this.onMouseleave,
        dropdownOffsetHeight: this.dropdownOffsetHeightData,
      })),
    };
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    listWidth: {
      type: String,
      default: 'auto',
    },
    closeOnClick: {
      type: Boolean,
      default: true,
    },
    right: {
      type: Boolean,
      default: false,
    },
    onClick: {
      type: Function,
      default: () => {},
    },
    onMouseleave: {
      type: Function,
      default: () => {},
    },
    onMouseenter: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    minWidth: {
      type: String,
      default: '0px',
    },
    round: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      activeElement: null,
      open: false,
      dropdownOffsetHeightData: 0,
    };
  },
  computed: {
    inputListeners() {
      const vm = this;
      // `Object.assign` merges objects together to form a new object
      return {
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        // This ensures that the component works with v-model
        'update:modelValue': function (event) {
          vm.$emit('update:modelValue', event.target.value);
        },
      };
    },
  },
  methods: {
    mouseenter(e) {
      this.dropdownOffsetHeightData = this.$refs.dropdown.offsetHeight;
      this.handleActiveElementChange(e.target);
    },
    mouseleave(e) {
      if (this.outsideRoot(e.relatedTarget)) {
        this.handleActiveElementChange(null);
      }
    },
    handleActiveElementChange(element) {
      this.activeElement = element;
      this.open = !this.outsideRoot(element);
      this.$forceUpdate();
    },
    outsideRoot(element) {
      return !this.$refs?.dropdown?.contains(element);
    },
  },
};
</script>

<style lang="less" scoped>
.dropdown {
  position: relative;
  height: 100%;
  line-height: 28px;
  cursor: pointer;
  .dropdown-open .dppl-dropdown-button {
    background-color: transparent !important;
    color: @white !important;
  }
  .dropdown-open .dppl-round-button,
  .dropdown-open :deep(.icon-text-pair),
  .dropdown-open p,
  .dropdown-open h5,
  .dropdown-open span,
  .dropdown-open svg,
  .dropdown-open .dppl-round-button:focus {
    background-color: transparent;
    border-color: @text-brand;
    color: @text-brand !important;
  }
}
.dropdown.round {
  border-radius: 8px;
  padding: 0 10px;
  color: @text-darkest;
  &.dropdown-open {
    background-color: fade(@bg-brand-default, 5%);
    color: @text-brand;
  }
}
</style>
